import { max } from "date-fns";

export const koReportingContainerStyles = {
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexGrow: 1,
        marginTop: 5,
        typography: 'body1',
        // minHeight:'100vh',
    },
    table: {
        width: '100%',    
        maxHeight: 1000,  
        // overflowY: 'scroll',
        // background: 'inherit',
        boxShadow: '3px 3px 7px 1px #ccc',
        '& .MuiTableCell-root': {
            fontSize: '11px',
            fontWeight: 'bold',
            color: '#000',
        },
        '& .MuiTable-root': {
            '& .MuiTableHead-root': {
                '& .MuiTableRow-root': {
                    position: 'sticky',
                    top: 0,
                    zIndex: 100,
                }
            },

        }
    },
    formTable: {
        width: 800,
        background: 'inherit',
        alignItem:'center',
        '& .MuiTableCell-root': {
            fontSize: '14px',
            fontWeight: 'normal',
            color: '#fff',
        },
        '& .MuiTable-root': {
            '& .MuiTableHead-root': {
                '& .MuiTableRow-root': {
                    position: 'sticky',
                    top: 0,
                    zIndex: 100,
                }
            },
        }
    },
    // tableStyles:
    // {
    //     width: '100%',
    //     border: '16px solid black',
    //     borderRadius: '20px'
    // }
}
